// Static navigation data
// When API is ready: fetch from GET /api/nav/menu and merge with these as fallback

export const NAV_PRODUCTS = [
  {
    id: 'industrial-computing',
    label: 'Industrial Computing',
    url: '/products/industrial-computing/',
    items: [
      { label: 'Panel PCs', url: '/categories/panel-pcs/' },
      { label: 'Box PCs', url: '/categories/box-pcs/' },
      { label: 'Rackmount Computers', url: '/categories/rackmount-computers/' },
      { label: 'DIN-Rail Computers', url: '/categories/din-rail-computers/' },
      { label: 'Vehicle Computers', url: '/categories/vehicle-computers/' },
      { label: 'Touch Panel Computers', url: '/categories/touch-panel-computers/' },
    ],
  },
  {
    id: 'embedded-computers',
    label: 'Embedded Computers',
    url: '/products/embedded-computers/',
    items: [
      { label: 'COM Express Modules', url: '/categories/com-express-modules/' },
      { label: 'Single Board Computers', url: '/categories/single-board-computers/' },
      { label: 'SMARC Modules', url: '/categories/smarc-modules/' },
      { label: 'Mini-ITX Boards', url: '/categories/mini-itx-boards/' },
      { label: 'Embedded Motherboards', url: '/categories/embedded-motherboards/' },
      { label: 'PC/104 Boards', url: '/categories/pc-104-boards/' },
    ],
  },
  {
    id: 'ini',
    label: 'Industrial NW Infrastructure',
    url: '/products/industrial-nw-infrastructure/',
    items: [
      { label: 'Ethernet Switches', url: '/categories/ethernet-switches/' },
      { label: 'Layer 2 Switches', url: '/categories/layer-2-switches/' },
      { label: 'Modular Managed Switches', url: '/categories/modular-managed-switches/' },
      { label: 'Layer 3 Switches', url: '/categories/layer-3-switches/' },
      { label: 'POE Ethernet Switch', url: '/categories/poe-ethernet-switch/' },
      { label: 'Wireless AP Clients', url: '/categories/wireless-ap-clients/' },
      { label: 'Ethernet to Fiber Media converter', url: '/categories/ethernet-to-fiber-media-converter/' },
      { label: 'POE Injector Splitter', url: '/categories/poe-injector-splitter/' },
      { label: 'IEC-61850-3 Switches', url: '/categories/iec-61850-3-switches/' },
      { label: 'Routers Firewalls', url: '/categories/routers-firewalls/' },
      { label: 'NW Security Appliances', url: '/categories/nw-security-appliances/' },
      { label: 'Cellular / IIOT Gateway', url: '/categories/cellular-iiot-gateway/' },
      { label: 'NW Management', url: '/categories/nw-management/' },
    ],
  },
  {
    id: 'data-acquisition',
    label: 'Data Acquisition',
    url: '/products/data-acquisition/',
    items: [
      { label: 'Remote I/O Units', url: '/categories/remote-io-units/' },
      { label: 'Data Loggers', url: '/categories/data-loggers/' },
      { label: 'Signal Conditioners', url: '/categories/signal-conditioners/' },
      { label: 'Protocol Converters', url: '/categories/protocol-converters/' },
      { label: 'DAQ Systems', url: '/categories/daq-systems/' },
      { label: 'Distributed I/O', url: '/categories/distributed-io/' },
    ],
  },
  {
    id: 'edge-connectivity',
    label: 'Industrial Edge Connectivity',
    url: '/products/industrial-edge-connectivity/',
    items: [
      { label: 'Industrial IoT Gateways', url: '/categories/industrial-iot-gateways/' },
      { label: 'Serial Device Servers', url: '/categories/serial-device-servers/' },
      { label: 'USB-to-Serial Converters', url: '/categories/usb-to-serial-converters/' },
      { label: 'Modbus Gateways', url: '/categories/modbus-gateways/' },
      { label: 'OPC UA Servers', url: '/categories/opc-ua-servers/' },
      { label: 'Edge Controllers', url: '/categories/edge-controllers/' },
    ],
  },
  {
    id: 'defense',
    label: 'Defense Products',
    url: '/products/defense-products/',
    items: [
      { label: 'Rugged Computers', url: '/categories/rugged-computers/' },
      { label: 'EMD', url: '/categories/emd/' },
      { label: 'MME', url: '/categories/mme/' },
      { label: 'RDACS', url: '/categories/rdacs/' },
      { label: 'Mission Critical Systems', url: '/categories/mission-critical-systems/' },
      { label: 'Vetronics', url: '/categories/vetronics/' },
    ],
  },
];

export const NAV_INDUSTRIES = [
  {
    label: 'Technology',
    url: '/industries/technology/',
    items: [
      { label: 'Network Security & Cybersecurity', url: '/industries/technology/network-security-cybersecurity/' },
      { label: 'Time-sensitive Networking (TSN)', url: '/industries/technology/time-sensitive-networking-tsn/' },
      { label: 'Single-pair Ethernet (SPE)', url: '/industries/technology/single-pair-ethernet-spe/' },
      { label: 'Ethernet-APL', url: '/industries/technology/ethernet-apl/' },
      { label: 'Private 5G Networks', url: '/industries/technology/private-5g-networks/' },
      { label: 'Harnessing OT Data', url: '/industries/technology/harnessing-ot-data/' },
      { label: 'IIoT', url: '/industries/technology/iiot/' },
    ],
  },
  { label: 'Manufacturing', url: '/industries/manufacturing/' },
  { label: 'Rail', url: '/industries/rail/' },
  { label: 'Power', url: '/industries/power/' },
  { label: 'Oil & Gas', url: '/industries/oil-and-gas/' },
  { label: 'Marine', url: '/industries/marine/' },
  { label: 'Intelligent Transportation', url: '/industries/intelligent-transportation/' },
  { label: 'Smart Infrastructure', url: '/industries/smart-infrastructure/' },
  { label: 'Defense', url: '/industries/defense/' },
];

